// HBO Bachelor Studies
// University of Applied Sciences Bachelor programs with comprehensive categories

export const HBO_BACHELOR_STUDIES = {
  'Economie & Bedrijfskunde': {
    'Financiën & Accountancy': [
      'Accountancy',
      'Finance & Control',
      'Finance, Tax and Advice',
      'International Financial Management en Control',
      'Master of Financial Management and Control',
      'Social Financiële Dienstverlening'
    ],
    'Bedrijfskunde & Management': [
      'Bedrijfskunde',
      'Business Administration',
      'Ondernemerschap en Retail Management',
      'Risicomanagement',
      'Vastgoedkunde'
    ],
    'Marketing & Commercie': [
      'Commerciële Economie',
      'E-Commerce',
      'Online Marketing',
      'Sales en Accountmanagement',
      'Crossmediale communicatie'
    ]
  },
  'Management & Organisatie': {
    'Algemeen Management': [
      'Management en Organisatie',
      'Business Administration',
      'Master Begeleidingskunde',
      'Master Management en Innovatie in Maatschappelijke Organisaties'
    ],
    'Ondernemerschap & Innovatie': [
      'Business Innovation (EN)',
      'Creative Business',
      'Ondernemerschap Retail and Management'
    ],
    'Human Resource & Coaching': [
      'Human Resource Management',
      'Organisatiecoaching'
    ],
    'Facility & Veiligheid': [
      'Facility Management',
      'Facilitair Eventmanagement',
      'Integrale Bedrijfsvoering',
      'Integrale Veiligheidskunde',
      'Safety and Security Management Studies'
    ],
    'Internationaal & Logistiek': [
      'AMSIB - International Business',
      'European Studies',
      'Shipping and Transport'
    ]
  },
  'Techniek & ICT': {
    'Engineering & Technologie': [
      // Automotive
      'Automotive',
      'Automotive Engineering',
      'Maritiem Officier',
      // Biomedical
      'Biomedische Technologie',
      'Mens en Techniek',
      // Civil
      'Built Environment',
      'Civiele Techniek',
      'Stedenbouw',
      'Ruimtelijke Ontwikkeling',
      // Chemical
      'Chemische Technologie',
      'Process en Food Technology',
      // Electrical
      'Elektrotechniek',
      'Engineering: Elektrotechniek',
      'Smart Technology',
      // General
      'Engineering',
      'Engineering: Technische Bedrijfskunde',
      'Engineering: Werktuigbouwkunde',
      'Next Level Engineering',
      // Industrial
      'Industrial Design Engineering',
      'Industrial Engineering and Management',
      'Mechatronica',
      // Math/Physics
      'Technische Natuurkunde',
      'Toegepaste Wiskunde',
      // Design
      'Engineering: Product Ontwerpen',
      // AI
      'Artificial Intelligence'
    ],
    'Informatica & Cybersecurity': [
      'Cyber Security Engineering',
      'Cybersecurity',
      'HBO-ICT',
      'Informatica',
      'Information Security',
      'Information Technology',
      'IT Service Management',
      'Artificial Intelligence'
    ],
    'Supply Chain & Bouwmanagement': [
      'Integraal Bouwmanagement',
      'International Supply Chain Management',
      'Logistics Engineering',
      'Logistics Management',
      'Maintenance'
    ],
    'Luchtvaart & Transport': [
      'Aviation',
      'Luchtvaarttechnologie'
    ]
  },
  'Gezondheid & Zorg': {
    'Medische Zorg & Therapie': [
      'Ergotherapie',
      'Ergotherapie: Leerroute IPZ',
      'Fysiotherapie',
      'Fysiotherapie: Leerroute IPZ',
      'Huidtherapie',
      'Physician Assistant',
      'Podotherapie',
      'Verloskunde'
    ],
    'Gezondheid & Voeding': [
      'Advanced Health Informatics Practice',
      'Food Commerce & Technology',
      'Gezondheid',
      'Management in de Zorg',
      'Medical Imaging and Radiation Therapy',
      'Voeding en Diëtetiek'
    ],
    'Sociale & Psychische Zorg': [
      'Interprofessionele Paramedische Zorg',
      'Oefentherapie: Leerroute IPZ',
      'Social Work',
      'Toegepaste Psychologie'
    ]
  },
  'Recht & Bestuur': {
    'Bestuur & Beleidsvorming': [
      'Bestuurskunde',
      'European Studies',
      'International Public Policy and Leadership'
    ],
    'Juridische Studies': [
      'Forensisch Onderzoek',
      'HBO-Rechten',
      'Sociaal Juridische Dienstverlening/Expert'
    ]
  },
  'Onderwijs & Opvoeding': {
    'Lerarenopleiding - Algemeen': [
      'Kopopleiding Tweedegraadsleraar',
      'Leraar Aardrijkskunde',
      'Leraar Biologie',
      'Leraar Duits',
      'Leraar Economie',
      'Leraar Engels',
      'Leraar Frans',
      'Leraar Geschiedenis',
      'Leraar Gezondheidszorg en Welzijn',
      'Leraar Horeca en Voeding',
      'Leraar Maatschappijleer',
      'Leraar Natuurkunde',
      'Leraar Nederlands',
      'Leraar Omgangskunde',
      'Leraar Pedagogiek',
      'Leraar Scheikunde',
      'Leraar Spaans',
      'Leraar Technisch Beroepsonderwijs',
      'Leraar Wiskunde'
    ],
    'Lerarenopleiding - Specifieke Richtingen': [
      'Academie/Leraar voor Lichamelijke Opvoeding (ALO)',
      'Docent Beeldende Kunst en Vormgeving',
      'Docent Theater',
      'Educatief Professional Beroepsonderwijs',
      'Pabo',
      'Pabo-ALO (Leraar Basisonderwijs)',
      'Pedagogiek',
      'Pedagogisch Educatief Professional',
      'Universitaire Pabo'
    ],
    'Onderwijs & Innovatie': [
      'Educational Leadership',
      'Leren Innoveren',
      'Logopedie',
      'Master Jonge Kind',
      'Taalbewust Leren'
    ]
  },
  'Media, Communicatie & Creativiteit': {
    'Communicatie & Journalistiek': [
      'Communicatie',
      'Communication and Multimedia Design',
      'International Communication Management',
      'Journalistiek'
    ],
    'Design & Creatieve Sector': [
      'AMFI - Amsterdam Fashion Institute',
      'Circus and Performance Art',
      'Crossmediale Communicatie',
      'Design – Art, Communication and Design',
      'Electronic Music',
      'Master Design'
    ],
    'Marketing & Sales': [
      'Marketing Management',
      'Sales en Accountmanagement'
    ]
  },
  'Sport & Bewegen': {
    'Sportonderwijs & Coaching': [
      'Academie/Leraar voor Lichamelijke Opvoeding (ALO)',
      'Lesgeven in Sport en Bewegen',
      'Sport Studies',
      'Sportkunde'
    ],
    'Sportmanagement & Marketing': [
      'Johan Cruyff Academy',
      'SPECO Sportcommunicatie',
      'SPECO Sportmarketing'
    ]
  }
};

export default HBO_BACHELOR_STUDIES;